<template>
  <Modal
    id="login-required" :closeable="false"
    size="lg"
    confirmText="Logga in"
    v-on:confirm="login()">
    <h2 class="text-t4 mb-2">Du har loggats ut</h2>
    <p>Du har varit inaktiv för länge, vänligen logga in igen.</p>


  </Modal>
</template>
<script>
import Modal from '@/components/ui/modal';
import Button from '@/components/ui/button';
export default {
  name: 'LoginRequired',
  components: { Modal, Button },
  data() {
    return {};
  },
  methods: {
    login() {
      document.removeEventListener('keyup', this._keyUpListeners);
      document.querySelector('html').classList.remove('modal-open');
      this.$router.push({ path: '/login?returnUrl=' + this.$router.currentRoute.path });
    },
  },
  mounted() {
    var a = this.$el.getElementsByTagName('button')[0];
    a.focus();
    a.addEventListener('keydown', function (e) {
      if (e.keyCode == 9 || e.which == 9) {
        e.preventDefault();
      }
    });
  },
};
</script>
